<template>
  <div class="activity-profile">
    <div class="display-flex activity-profile__top">
      <!-- {{datagetActivityList}}xx -->
      <div class="form-group select-status select-status--class">
        <select
          class="form-control"
          id="status"
          v-model="selectClaass"
          @change="handleSelectClaass"
        >
          <option value="0">Lớp - Tất cả</option>
          <option
            v-for="(option, index) of getListClass"
            :key="index"
            :value="option.classId"
          >
            {{ option.name }}
          </option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
      <div class="form-group select-status select-status--class">
        <select
          class="form-control"
          id="status"
          v-model="selectActivityTypeId"
          @change="handleSelectActivityTypeId"
        >
          <option value="0">Hoạt động - Tất cả</option>
          <option
            v-for="(option, index) of activityType"
            :key="index"
            :value="option.activityTypeId"
          >
            {{ option.name }}
          </option>
        </select>
        <i class="fa fa-angle-down"></i>
      </div>
      <div class="form">
        <form class="form-training">
          <input
            v-model.lazy="keyword"
            v-debounce="300"
            type="text"
            placeholder="Tìm kiếm"
            required="required"
          />
          <button type="submit">
            <i class="fa fa-search primary-color"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="activity-profile__mid">
      <div
        class="display-flex item-activity"
        v-for="(item, index) in datagetActivityList"
        :key="index"
      >
        <div class="display-flex-center">
          <span class="font-size-16 secondary-color-txt font-family-Semibold">{{
            moment(item.createAt).format(formatDate)
          }}</span>

          <div class="dropdown dropdown-account ml-5">
            <button
              style="display: none"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-h"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <!-- <a
                              class="dropdown-item"
                              href="javascript:;"
              >Chỉnh sửa</a>-->
              <a
                @click="deleteNotifile(item.activityLogId)"
                class="dropdown-item four-color"
                href="javascript:;"
                >Xóa hoạt động</a
              >
            </div>
          </div>
        </div>

        <span
          v-if="item.activityTypeId === typeAcExam"
          class="span-text font-size-16 font-sanpro title-color-gray"
          @click="directDetailPage(item)"
        >
          {{ item.nameActivity }} {{ item.nameSClass }} {{ item.nameExam }}
          <b>"câu {{ item.nameQuestion }}"</b>
        </span>
        <span
          v-else-if="
            item.activityTypeId === typeAcThematic ||
            item.activityTypeId === typeAcExerciseOther
          "
          class="span-text font-size-16 font-sanpro title-color-gray"
          @click="directDetailPage(item)"
        >
          {{ item.nameActivity }} {{ item.nameSClass }} {{ item.nameChapter }}
          <b>" câu {{ item.nameQuestion }}"</b>
        </span>
        <span
          v-else-if="item.activityTypeId === typeComoletetTheExam"
          class="span-text font-size-16 font-sanpro title-color-gray"
          @click="directDetailPage(item)"
        >
          {{ item.nameActivity }} {{ item.nameSClass }}
          <b>"{{ item.nameExam }}"</b>
        </span>
        <span
          v-else-if="item.activityTypeId === typeDoExercise"
          class="font-size-16 font-sanpro title-color-gray"
        >
          {{ item.nameActivity }} sách {{ item.nameBookType }}
          <b>"{{ item.nameBook }}"</b> {{ item.exerciseNumber }}:
          {{ item.bookIndexNameParent }}
        </span>
        <span v-else class="font-size-16 font-sanpro title-color-gray">
          {{ item.nameActivity }} {{ item.nameBookType }}
          <b>"{{ item.nameBook }}"</b> trang {{ item.pageNo }}
        </span>

        <div style="flex: 1"></div>

        <div class="display-flex-center">
          <span
            @click="directDetailPage(item)"
            class="span-text primary-color font-sanpro-semibold font-size-16 color_bg_gray_light btn-edit"
            >Tiếp tục</span
          >

          <div class="dropdown dropdown-account ml-1">
            <button
              class
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-h"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <!-- <a
                              class="dropdown-item"
                              href="javascript:;"
              >Chỉnh sửa</a>-->
              <a
                @click="deleteNotifile(item.activityLogId)"
                class="dropdown-item four-color"
                href="javascript:;"
                >Xóa hoạt động</a
              >
            </div>
          </div>
        </div>
      </div>
      <div id="ActivityProfile_end"></div>
      <!-- <p class="col-12 text-center pagiination-training">
        <Pagination @eventPagination="getTrainingPagination" :totalPage="pagingData.totalPage" />
      </p> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  STORE_KEY,
  TYPE_ACTIVE_ACTIVITY,
  TYPE_REPLY_ACTIVITY,
  TYPE_READ_BOOK_ACTIVITY,
  TYPE_EXERCISE_ACTIVITY,
  TYPE_EXERCISE_ACTIVITY_EXAM,
  TYPE_EXERCISE_ACTIVITY_THEMATIC,
  TYPE_EXERCISE_ACTIVITY_OTHER,
  TYPE_EXERCISE_ACTIVITY_COMPLETET_THE_EXAM,
} from "../../_store/constants";
import Pagination from "@/components/Pagination.vue";
import debounce from "@/directives/debounce";
import { apiDeleteActivity } from "./../../_api";
import moment from "moment";
export default {
  name: "ActivityProfile",
  directives: { debounce },
  components: {
    Pagination,
  },
  data() {
    return {
      elmEndItem: null,
      datagetActivityList: [],
      selectActivityTypeId: 0,
      activityType: [],
      selectClaass: 0,
      classId: 0,
      keyword: "",
      formatDate: "HH:mm - DD/MM/YYYY",
      pagingData: {},
      typeDoExercise: TYPE_EXERCISE_ACTIVITY,
      typeAcExam: TYPE_EXERCISE_ACTIVITY_EXAM,
      typeComoletetTheExam: TYPE_EXERCISE_ACTIVITY_COMPLETET_THE_EXAM,
      typeAcThematic: TYPE_EXERCISE_ACTIVITY_THEMATIC,
      typeAcExerciseOther: TYPE_EXERCISE_ACTIVITY_OTHER,
    };
  },
  computed: {
    ...mapGetters({
      paramActivityList: STORE_KEY + "/paramActivityList",
      getActivityList: STORE_KEY + "/getActivityList",
      getUserInfo: STORE_KEY + "/getUserInfo",
      getListClass: STORE_KEY + "/getListClass",
    }),
  },

  watch: {
    keyword: "ActivitySearch",
    paramActivityList: "changeParamActivityList",
    getActivityList(newVal) {
      if (newVal) {
        this.datagetActivityList = newVal.list;

        this.pagingData = newVal.paging;
      }
    },
  },
  mounted() {
    this.elmEndItem = document.getElementById("ActivityProfile_end");
    if (this.elmEndItem) {
      this.observer = new IntersectionObserver(this.handleScrollEnd, {
        threshold: 1,
      });
      this.observer.observe(this.elmEndItem);
    }
    this.actionGetListActivityType().then((res) => {
      this.activityType = res.data.list;
    });
    this.setParamActivityList({
      ...this.paramActivityList,
      Creatat: "",
      UserId: 0,
      PageIndex: 1,
      PageSize: 10,
      TotalRecord: 0,
      totalPage: 0,
      activityTypeId: 0,
    });
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
      "setParamActivityList",
      "actionActivityList",
      "actionGetListActivityType",
    ]),
    ...mapActions(`common`, ["setLoading"]),
    moment,

    handleSelectActivityTypeId() {
      this.setParamActivityList({
        ...this.paramActivityList,
        activityTypeId: this.selectActivityTypeId,
        PageIndex: 1,
      });
    },

    handleSelectClaass() {
      this.setParamActivityList({
        ...this.paramActivityList,
        ClassId: this.selectClaass,
        PageIndex: 1,
      });
    },

    deleteNotifile(id) {
      let values = {};
      values.id = id;
      apiDeleteActivity(values).then((res) => {
        if (res.status === "success") {
          this.actionActivityList(this.paramActivityList);
          this.$toast.success("Xóa thành công");
        }
      });
    },

    directDetailPage(item) {
      console.log("item direct: ", item);
      // return;
      switch (item.activityTypeId) {
        case TYPE_READ_BOOK_ACTIVITY:
          this.$router.push({
            name: "ebook-read-book",
            params: { id: item.bookId, slug: item.slug },
            query: { page: item.pageNo },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY:
          this.$router.push({
            name: "exerciseDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              bookType: item.bookGroupId,
              practiceType: item.practiceTypeId,
            },
            query: { danhmuc: item.bookIndexId, cauhoi: item.questionId },
          });
          break;
        case TYPE_ACTIVE_ACTIVITY:
          this.$router.push({
            name: "ebook-detail",
            params: { id: item.bookId, slug: item.slug },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_EXAM:
        case TYPE_EXERCISE_ACTIVITY_COMPLETET_THE_EXAM:
          this.$router.push({
            name: "exerciseExamQuestion",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 9,
              id: item.examId,
            },
            query: {
              cauhoi: item.questionId,
            },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_THEMATIC:
          this.$router.push({
            name: "exerciseThematicDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 8,
              id: item.chapterId,
            },
            query: {
              cauhoi: item.questionId,
            },
          });
          break;
        case TYPE_EXERCISE_ACTIVITY_OTHER:
          this.$router.push({
            name: "exerciseOtherDetail",
            params: {
              classId: item.classId,
              subjectId: item.subjectId,
              typeId: 1,
              id: item.chapterId,
            },
            query: {
              cauhoi: item.questionId,
            },
          });
          break;
      }
    },

    ActivitySearch() {
      this.setParamActivityList({
        ...this.paramActivityList,
        Keyword: this.keyword,
        PageIndex: 1,
      });
    },

    changeParamActivityList() {
      this.actionActivityList(this.paramActivityList).then((res) => {
        this.datagetActivityList =
          this.paramActivityList.PageIndex === 1
            ? res.list
            : [...this.datagetActivityList, ...res.list];
      });
    },
    getDefaultParamActivityList() {
      this.actionActivityList({
        ...this.paramActivityList,
        Keyword: this.keyword,
        PageIndex: 1,
      }).then((res) => {
        this.datagetActivityList =
          this.paramActivityList.PageIndex === 1
            ? res.list
            : [...this.datagetActivityList, ...res.list];
      });
    },

    getTrainingPagination(value) {
      this.setParamActivityList({
        ...this.paramActivityList,
        PageIndex: value,
      });
    },
    handleScrollEnd() {
      console.log("this.pagingData", this.pagingData);
      console.log("this.paramActivityList", this.paramActivityList);
      console.log(
        "this.paramActivityList.pageIndex",
        this.paramActivityList.PageIndex
      );
      if (
        this.pagingData &&
        this.pagingData.totalPage &&
        this.paramActivityList.PageIndex < this.pagingData.totalPage
      ) {
        this.setParamActivityList({
          ...this.paramActivityList,
          PageIndex: this.paramActivityList.PageIndex + 1,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-profile__mid {
  margin-bottom: 60px !important;
  .item-activity {
    padding: 10px 0px;
    border-bottom: 1px solid #dee2e6;
  }
  .span-text {
    cursor: pointer;
  }
}
.activity-profile {
  margin-top: 35px;
  &__top {
    margin-bottom: 15px;
  }
}
.select-status {
  position: relative;
  margin-right: 20px;
  select {
    border: none;
    background: #f3f6fb;
    border-radius: 20px;
    height: 30px;
    font-size: 15px;
    -webkit-appearance: none;
    width: 200px;
  }
  i {
    position: absolute;
    top: 7px;
    left: 176px;
  }
}
table {
  .tbody {
    tr:first-child {
      border-top: 2px solid #fff !important;
    }
    tr:last-child {
      border-top: 1px solid #e2dfdf !important;
    }
  }
}

.dropdown button {
  width: 30px;
  background: none;
  color: #879aa9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background-color: #e1efff;
}
.dropdown button:focus {
  background: #e1efff !important;
  color: #124abe;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}

.btn-edit {
  height: 30px;
  line-height: 30px;
  border: 0;
  outline: 0;
  border-radius: 20px;
  padding: 0 15px;
}
</style>